import React from "react";
import { Typography, Box, Divider } from "@mui/material";
import { PanelProps } from "./Panel.types";

function Panel(props: PanelProps) {
  const {
    actions,
    children,
    title,
    subtitle,
    showDivider,
    titleMarginBottom,
    ...other
  } = props;

  return (
    <Box
      {...other}
      sx={(theme) => ({
        display: "flex",
        background: "#FFF",
        border: `0.5px solid ${theme.palette.grey[40]}`,
        borderRadius: { md: "12px" },
        flexDirection: "column",
      })}
      component="section"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "20px 20px 0 20px",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              flex: 1,
            }}
            color="grey.100"
            m={0}
            mb={titleMarginBottom}
            variant="h3"
            display="block"
          >
            {title}
          </Typography>
          {subtitle && (
            <Box
              sx={{
                marginTop: 5,
              }}
            >
              {subtitle}
            </Box>
          )}
        </Box>
        {actions}
      </Box>
      {showDivider && <Divider sx={{ mt: 4, color: "grey.40" }} />}
      <Box>{children}</Box>
    </Box>
  );
}

export default Panel;
